import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-pilates': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-pilates&exp=web_buy_6_get_12_pilates~1
			paywall: {
				experiment: () =>
					import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_buy_6_get_12_pilates'),
			},
		},
	},
]

export default config
